import { useEffect, forwardRef } from 'react'
import '../components/HomeHero.css';
import AOS from "aos";
import "aos/dist/aos.css";
import { useAppContext } from "./AppProvider"



const HomeHero = forwardRef((props, ref) => {

const { gpageTransition, openCalender, openCalendly } = useAppContext();

    



    useEffect(() => {
        AOS.init({
            duration: 500,   // animation duration
            // once: true,      // whether animation should happen only once
            easing: "ease-out-quart",
        });
    }, []);


    return (
        <>
            <section className="hero" ref={ref}>
                <div className="container">
                    <div className='grid grid-cols-1'>
                        <div className='2xl:w-3/5 xl:w-3/4 mx-auto text-center'>
                            {/* <h1 className="" data-aos="fade-up">We are turning ordinary into 
                            <span className="text-primary font-semibold"> Extraordinary</span>
                        </h1> */}

                            <h1 className="" data-aos="fade-up">Turning Businesses into
                                <span className="text-primary font-semibold"> Success Stories</span>
                            </h1>


                            <p className="w-full md:w-3/4 mx-auto" data-aos="fade-up" data-aos-delay="100">Creative. Strategic. Impactful digital experiences that connect brands with their audience</p>


                            <div className="flex gap-5 justify-center">
                                <div className="hidden md:flex">
                                    <button className=' ' data-aos="fade-up" data-aos-delay="200" onClick={(e) => gpageTransition('/contact')}>
                                        <div>Request a quote<i></i></div>
                                    </button>
                                </div>

                                {/* <button onClick={openCalender} className='reverse' data-aos="fade-up" data-aos-delay="200" > 
                                    <div>Book a free call<i></i></div>
                                </button> */}

                                <button onClick={openCalendly} className='reverse' data-aos="fade-up" data-aos-delay="200" >
                                    <div>Book a free call<i></i></div>
                                </button>




                            </div>
                        </div>


                    </div>


                </div>
            </section>
        </>
    )
});

export default HomeHero

